// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha1_payout from "./buhta_payroll_v1alpha1_payout.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetPayoutRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout_service.ml",
      517,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetPayoutResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout_service.ml",
      580,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListPayoutsRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout_service.ml",
      642,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListPayoutsResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha1_payout_service.ml",
      708,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.v1alpha1.GetPayoutRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.GetPayoutRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.GetPayoutRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPayoutRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.payroll.v1alpha1.GetPayoutResponse";
}

function make$1(payout, param) {
  return {
          payout: payout
        };
}

const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha1_payout.Buhta.Payroll.V1alpha1.Payout;

const merge_payout = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "payout",
            "payout"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          payout: Curry._2(merge_payout, t1.payout, t2.payout)
        };
}

function spec$1(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha1_payout.Buhta.Payroll.V1alpha1.Payout;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "payout",
                    "payout"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.payout);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(payout) {
  return {
          payout: payout
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.GetPayoutResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.payout);
  };
}

function constructor$3(payout) {
  return {
          payout: payout
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.GetPayoutResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPayoutResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.payroll.v1alpha1.ListPayoutsRequest";
}

function make$2(project_id, employee_id, grid, param) {
  return {
          project_id: project_id,
          employee_id: employee_id,
          grid: grid
        };
}

const merge_project_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "project_id",
            "projectId"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_employee_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          project_id: Curry._2(merge_project_id, t1.project_id, t2.project_id),
          employee_id: Curry._2(merge_employee_id, t1.employee_id, t2.employee_id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "project_id",
                    "projectId"
                  ],
                  Ocaml_protoc_plugin__Spec.string
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "employee_id",
                        "employeeId"
                      ],
                      Ocaml_protoc_plugin__Spec.string
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "grid",
                            "grid"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: $$let.name,
                                make: $$let.make,
                                from_proto: $$let.from_proto,
                                from_proto_exn: $$let.from_proto_exn,
                                to_proto: $$let.to_proto,
                                to_proto$p: $$let.to_proto$p,
                                merge: $$let.merge,
                                to_json: $$let.to_json,
                                from_json_exn: $$let.from_json_exn,
                                from_json: $$let.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._4(serialize$2, writer, param.project_id, param.employee_id, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(project_id, employee_id, grid) {
  return {
          project_id: project_id,
          employee_id: employee_id,
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.ListPayoutsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.project_id, param.employee_id, param.grid);
  };
}

function constructor$5(project_id, employee_id, grid) {
  return {
          project_id: project_id,
          employee_id: employee_id,
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.ListPayoutsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListPayoutsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.payroll.v1alpha1.ListPayoutsResponse";
}

function make$3(payoutsOpt, param) {
  const payouts = payoutsOpt !== undefined ? payoutsOpt : /* [] */0;
  return {
          payouts: payouts
        };
}

const $$let$2 = Buhta_payrollapis__Buhta_payroll_v1alpha1_payout.Buhta.Payroll.V1alpha1.Payout;

const merge_payouts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "payouts",
            "payouts"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          payouts: Curry._2(merge_payouts, t1.payouts, t2.payouts)
        };
}

function spec$3(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha1_payout.Buhta.Payroll.V1alpha1.Payout;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "payouts",
                    "payouts"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.payouts);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(payouts) {
  return {
          payouts: payouts
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha1.ListPayoutsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.payouts);
  };
}

function constructor$7(payouts) {
  return {
          payouts: payouts
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha1.ListPayoutsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListPayoutsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const getPayout_0 = {
  name: GetPayoutRequest.name,
  make: GetPayoutRequest.make,
  from_proto: GetPayoutRequest.from_proto,
  from_proto_exn: GetPayoutRequest.from_proto_exn,
  to_proto: GetPayoutRequest.to_proto,
  to_proto$p: GetPayoutRequest.to_proto$p,
  merge: GetPayoutRequest.merge,
  to_json: GetPayoutRequest.to_json,
  from_json_exn: GetPayoutRequest.from_json_exn,
  from_json: GetPayoutRequest.from_json
};

const getPayout_1 = {
  name: GetPayoutResponse.name,
  make: GetPayoutResponse.make,
  from_proto: GetPayoutResponse.from_proto,
  from_proto_exn: GetPayoutResponse.from_proto_exn,
  to_proto: GetPayoutResponse.to_proto,
  to_proto$p: GetPayoutResponse.to_proto$p,
  merge: GetPayoutResponse.merge,
  to_json: GetPayoutResponse.to_json,
  from_json_exn: GetPayoutResponse.from_json_exn,
  from_json: GetPayoutResponse.from_json
};

const getPayout = [
  getPayout_0,
  getPayout_1
];

const listPayouts_0 = {
  name: ListPayoutsRequest.name,
  make: ListPayoutsRequest.make,
  from_proto: ListPayoutsRequest.from_proto,
  from_proto_exn: ListPayoutsRequest.from_proto_exn,
  to_proto: ListPayoutsRequest.to_proto,
  to_proto$p: ListPayoutsRequest.to_proto$p,
  merge: ListPayoutsRequest.merge,
  to_json: ListPayoutsRequest.to_json,
  from_json_exn: ListPayoutsRequest.from_json_exn,
  from_json: ListPayoutsRequest.from_json
};

const listPayouts_1 = {
  name: ListPayoutsResponse.name,
  make: ListPayoutsResponse.make,
  from_proto: ListPayoutsResponse.from_proto,
  from_proto_exn: ListPayoutsResponse.from_proto_exn,
  to_proto: ListPayoutsResponse.to_proto,
  to_proto$p: ListPayoutsResponse.to_proto$p,
  merge: ListPayoutsResponse.merge,
  to_json: ListPayoutsResponse.to_json,
  from_json_exn: ListPayoutsResponse.from_json_exn,
  from_json: ListPayoutsResponse.from_json
};

const listPayouts = [
  listPayouts_0,
  listPayouts_1
];

const V1alpha1_PayoutService = {
  GetPayout: {
    name: "/buhta.payroll.v1alpha1.PayoutService/GetPayout",
    package_name: "buhta.payroll.v1alpha1",
    service_name: "PayoutService",
    method_name: "GetPayout",
    $$Request: {
      name: GetPayoutRequest.name,
      make: GetPayoutRequest.make,
      from_proto: GetPayoutRequest.from_proto,
      from_proto_exn: GetPayoutRequest.from_proto_exn,
      to_proto: GetPayoutRequest.to_proto,
      to_proto$p: GetPayoutRequest.to_proto$p,
      merge: GetPayoutRequest.merge,
      to_json: GetPayoutRequest.to_json,
      from_json_exn: GetPayoutRequest.from_json_exn,
      from_json: GetPayoutRequest.from_json
    },
    $$Response: {
      name: GetPayoutResponse.name,
      make: GetPayoutResponse.make,
      from_proto: GetPayoutResponse.from_proto,
      from_proto_exn: GetPayoutResponse.from_proto_exn,
      to_proto: GetPayoutResponse.to_proto,
      to_proto$p: GetPayoutResponse.to_proto$p,
      merge: GetPayoutResponse.merge,
      to_json: GetPayoutResponse.to_json,
      from_json_exn: GetPayoutResponse.from_json_exn,
      from_json: GetPayoutResponse.from_json
    }
  },
  getPayout: getPayout,
  ListPayouts: {
    name: "/buhta.payroll.v1alpha1.PayoutService/ListPayouts",
    package_name: "buhta.payroll.v1alpha1",
    service_name: "PayoutService",
    method_name: "ListPayouts",
    $$Request: {
      name: ListPayoutsRequest.name,
      make: ListPayoutsRequest.make,
      from_proto: ListPayoutsRequest.from_proto,
      from_proto_exn: ListPayoutsRequest.from_proto_exn,
      to_proto: ListPayoutsRequest.to_proto,
      to_proto$p: ListPayoutsRequest.to_proto$p,
      merge: ListPayoutsRequest.merge,
      to_json: ListPayoutsRequest.to_json,
      from_json_exn: ListPayoutsRequest.from_json_exn,
      from_json: ListPayoutsRequest.from_json
    },
    $$Response: {
      name: ListPayoutsResponse.name,
      make: ListPayoutsResponse.make,
      from_proto: ListPayoutsResponse.from_proto,
      from_proto_exn: ListPayoutsResponse.from_proto_exn,
      to_proto: ListPayoutsResponse.to_proto,
      to_proto$p: ListPayoutsResponse.to_proto$p,
      merge: ListPayoutsResponse.merge,
      to_json: ListPayoutsResponse.to_json,
      from_json_exn: ListPayoutsResponse.from_json_exn,
      from_json: ListPayoutsResponse.from_json
    }
  },
  listPayouts: listPayouts
};

const V1alpha1 = {
  GetPayoutRequest: GetPayoutRequest,
  GetPayoutResponse: GetPayoutResponse,
  ListPayoutsRequest: ListPayoutsRequest,
  ListPayoutsResponse: ListPayoutsResponse,
  PayoutService: V1alpha1_PayoutService
};

const Payroll = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Payroll: Payroll
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetPayoutRequest Not a pure module */
